import { createRequest } from '@shared/services';

export async function postRequestUpdateEmail({ email }: { email: string }) {
    const request = createRequest<BasicSuccessResponse>({
        url: '/member/request-update-email',
        method: 'POST',
        data: { email },
        withAuthorization: true,
    });

    return request.execute();
}
